import { onBeforeUnmount, onMounted } from 'vue';

/** reka draws every select, popover and dropdown menu inside an element with this attribute. */
const MENU_SELECTOR = '[data-reka-popper-content-wrapper]';

/**
 * Hands a dialog the key presses made inside its pickers' open menus.
 *
 * A dialog hears key presses through its own box. A picker's open menu is drawn at the end of the
 * page instead, outside that box, so a key pressed in it never reaches the dialog. Pressing
 * Cmd+Enter while typing in a bucket search box would then do nothing. This listens on the whole
 * page while `isActive` is true, and passes on only the key presses made inside an open menu. The
 * rest already reach the dialog, so none is handled twice.
 */
export function useSubmitShortcutFromMenus(isActive: () => boolean, onKeydown: (event: KeyboardEvent) => void): void {
    function onDocumentKeydown(event: KeyboardEvent): void {
        if (!isActive()) return;
        if (!(event.target instanceof Element) || !event.target.closest(MENU_SELECTOR)) return;
        onKeydown(event);
    }

    onMounted(() => document.addEventListener('keydown', onDocumentKeydown));
    onBeforeUnmount(() => document.removeEventListener('keydown', onDocumentKeydown));
}
